module.exports = __webpack_public_path__ + "media/core_static/32px-7b8ef980.png";